// Lins
import React, { Component } from "react";
import Cookies from "js-cookie";
import { browserHistory } from "react-router";

// Components
import Divider from "../component/Divider";
import { ButtonSpocket } from "shared_components";
import SocialButton from "../component/SocialButton";
import SignUpFormContainer from "./signup/SignUpFormContainer";

// Images
import spocketLogo from "../images/spocket-logo.svg";
import iconSetPrices from "../images/icon-set-prices.svg";
import iconMakeSales from "../images/icon-make-sales.svg";
import iconPushToStore from "../images/icon-push-to-store.svg";
import iconFindImportProducts from "../images/icon-find-import-products.svg";

// Style
import "./Signup.css";
import {
  Card,
  Icon,
  Title,
  Header,
  Subtitle,
  SpocketEducationContainer,
} from "./CreateAccountStyle";

// Utils
import { formatUtm } from "../utils/utm";

const SignupButtonTheme = {
  backgroundColor: "#f1ecfb",
  borderRadius: "21px",
  padding: "11px 31px",
  fontSize: "14px",
  color: "#8144e5",
  fontWeight: 600,
  boxShadow: "none"
};

const cardsInfo = [
  {
    icon: iconFindImportProducts,
    title: "Find & import products",
    subtitle:
      "Search hundreds of thousands of fast shipping products from US and EU"
  },
  {
    icon: iconSetPrices,
    title: "Set prices",
    subtitle: "Choose a competitive price to maximize sales "
  },
  {
    icon: iconPushToStore,
    title: "Connect and push to store",
    subtitle: "Connect your store with Spocket and push your products"
  },
  {
    icon: iconMakeSales,
    title: "Make Sales",
    subtitle:
      "Everything is ready, promote your store and your orders are managed automatically"
  }
];

class Signup extends Component {
  componentDidMount = () => {
    const spocketUtm = Cookies.get("spocket_utm");
    const formatedSpocketUtm = spocketUtm ? formatUtm(spocketUtm) : {};

    if (Object.keys(formatedSpocketUtm).length === 0) {
      Cookies.set("spocket_utm", window.location.search, {
        expires: 30,
        domain: ".spocket.co",
        path: "/"
      });
    }
  };

  render() {
    return (
      <div className="Signup__container">
        <div className="Signup__container-top">
          <header>
            <img src={spocketLogo} alt="Spocket Logo" />
            <ButtonSpocket
              onClick={() => {
                browserHistory.push("/login");
              }}
              customButton={SignupButtonTheme}
            >
              Sign in
            </ButtonSpocket>
          </header>

          <div className="Signup__content">
            <main>
              <div className="Signup__titles">
                <div>You’re 2 minutes away</div>
                <div>from building your ecommerce empire</div>
              </div>
              <div className="Signup__form">
                <SignUpFormContainer />
              </div>
              <Divider>or</Divider>
              <div className="Signup__social-buttons">
                <SocialButton type="google">Sign up with Google</SocialButton>
                <SocialButton type="facebook">
                  Sign up with Facebook
                </SocialButton>
              </div>
            </main>
          </div>
        </div>

        <SpocketEducationContainer>
          <Header>How dropshipping with Spocket works</Header>
          {cardsInfo.map((card, index) => {
            return (
              <Card className="CreateAccount__card" key={index}>
                <Icon src={card.icon} alt="find product" />
                <Title>
                  {card.title}
                  <Subtitle>{card.subtitle}</Subtitle>
                </Title>
              </Card>
            );
          })}
        </SpocketEducationContainer>
      </div>
    );
  }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/CreateAccount.js